import dynamic from 'next/dynamic';
import { PropsWithChildren } from 'react';

const NoSSRBase = ({ children }: PropsWithChildren) => <>{children}</>;

export const NoSSR = dynamic(() => Promise.resolve(NoSSRBase), {
  loading: () => null,
  ssr: false,
});
